<template>
  <v-container>
    <div class="mt-4">
      <h1 class="text-center">Mon compte</h1>
      <div class="d-flex">
        <v-spacer />
        <v-form ref="form" class="login">
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-text-field label="Courriel" :value="email" outlined readonly />
              </v-col>
            </v-row>
            <p>
              Les informations de votre compte seront utilisées pour pré-remplir vos
              demandes.
            </p>
            <p>
              Si vous souhaitez changer votre adresse courriel, utilisez le bouton
              <strong>Changement courriel</strong> ci-dessous.
            </p>
            <a-modification-utilisateur-row v-model="info" />
          </v-card-text>
          <v-card-text class="d-flex">
            <div class="d-flex flex-column">
              <v-btn data-testid="changement-mot-de-passe" @click="changementMotPasse" color="primary">
                Changement mot de passe
              </v-btn>
              <v-btn data-testid="changement-courriel" @click="changementMail" color="primary" class="mt-1">
                Changement courriel
              </v-btn>
            </div>
            <v-spacer />
            <v-btn
              @click="modifier"
              :loading="working"
              color="primary"
              :disabled="unchanged"
              data-testid="valider-modifier-utilisateur"
            >
              Modifier
            </v-btn>
          </v-card-text>
        </v-form>
        <v-spacer />
      </div>
    </div>
    <a-changement-mot-passe-dialog ref="changementMotPasse" />
    <a-changement-mail-dialog ref="changementMail" />
    <a-confirm-navigation-dialog ref="confirm-navigation" />
  </v-container>
</template>

<script>
import makeNavigationGuard from "@/mixins/makeNavigationGuard";
import makeRemoteWorker from "@/mixins/makeRemoteWorker";
import { oauth2Service, principalService } from "@/services";
import { mapGetters } from "vuex";
export default {
  mixins: [makeRemoteWorker(), makeNavigationGuard({ item: "info" })],
  data() {
    return {
      email: "",
      unchanged: false,
      info: {
        nom: "",
        prenom: "",
        civilite: "M",
        adresse: "",
        complementAdresse: "",
        codePostal: "",
        ville: "",
      },
    };
  },
  methods: {
    changementMail() {
      this.$refs.changementMail.ouvre(this.email, () => {
        //noop
      });
    },
    changementMotPasse() {
      this.$refs.changementMotPasse.ouvre(() => {
        //noop
      });
    },
    modifier() {
      this.doWork({
        forms: [this.$refs.form],
        work() {
          const info = this.info;
          const modifier = {
            nom: info.nom,
            prenom: info.prenom,
            civilite: info.civilite,
            adresse: info.adresse,
            complementAdresse: info.complementAdresse,
            codePostal: info.codePostal,
            ville: info.ville,
          };
          return principalService
            .modifier(modifier)
            .then(() => oauth2Service.grantRefreshToken())
            .then(() => principalService.principal())
            .then(principal => {
              this.$store.commit("utilisateur/login", {
                email: info.email,
                ...principal,
              });
              this.initSnapshot();
              this.computeUnchanged();
            });
        },
        successText: "Vos informations ont été modifiées",
        errorText: "Erreur durant la modification",
      });
    },
    computeUnchanged() {
      this.unchanged = this.isSnapshotUnchanged();
    },
    syncStore() {
      this.email = this.emailUtilisateur;
      this.info.civilite = this.civiliteUtilisateur;
      this.info.nom = this.nomUtilisateur;
      this.info.prenom = this.prenomUtilisateur;
      this.info.adresse = this.adresseUtilisateur;
      this.info.complementAdresse = this.complementAdresseUtilisateur || "";
      this.info.codePostal = this.codePostalUtilisateur;
      this.info.ville = this.villeUtilisateur;
      this.initSnapshot();
      this.computeUnchanged();
    },
  },
  watch: {
    info: {
      handler() {
        this.computeUnchanged();
      },
      deep: true,
    },
  },
  mounted() {
    this.syncStore();
  },
  computed: {
    ...mapGetters({
      civiliteUtilisateur: "utilisateur/civilite",
      emailUtilisateur: "utilisateur/email",
      nomUtilisateur: "utilisateur/nom",
      prenomUtilisateur: "utilisateur/prenom",
      adresseUtilisateur: "utilisateur/adresse",
      complementAdresseUtilisateur: "utilisateur/complementAdresse",
      codePostalUtilisateur: "utilisateur/codePostal",
      villeUtilisateur: "utilisateur/ville",
    }),
  },
};
</script>
